import { useClassName } from '@/styles/Accordion';
import { Component, ComponentProps } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export type AccordionGroupProps = ComponentProps<'div'>;

export const AccordionGroupComponent: Component<AccordionGroupProps> = ({ children, ...props }) => {
  const className = useClassName('group', props);

  return <div {...mergeProps({ className }, props)}>{children}</div>;
};
